import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { useFormContext, Controller, useFieldArray } from 'react-hook-form';
import { useEffect, useState } from "react";
import SearchNotFound from "../SearchNotFound";

export default function RHFStaticDataAutoComplete({
    name,
    optionData,
    getOptionLabel,
    defaultValue = [],
    ...other
}) {
    const { control } = useFormContext();
    const { replace } = useFieldArray({ name, control });

    const [selected, setSelected] = useState(defaultValue);
    const [options, setOptions] = useState(() =>
        optionData?.filter(elem => !defaultValue.some(item => item.id === elem.id))
    );
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        replace(selected);
    }, [selected]);

    const safeGetOptionLabel = (option) => {
        if (typeof getOptionLabel === 'function') {
            return getOptionLabel(option);
        }
        return option?.name ?? option?.label ?? String(option);
    };

    function onChange(e, value) {
        setOptions(optionData?.filter(elem => !value.some(item => item.id === elem.id)));
        setSelected(value);
    }

    function onInputChange(e, newValue) {
        setInputValue(newValue);
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Autocomplete
                    options={options}
                    getOptionLabel={safeGetOptionLabel}
                    onChange={onChange}
                    inputValue={inputValue}
                    onInputChange={onInputChange}
                    noOptionsText={<SearchNotFound searchQuery={inputValue} />}
                    multiple
                    fullWidth
                    defaultValue={selected}
                    {...other}

                    renderTags={(value, getTagProps) => (
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',       
                                overflowY: 'auto',      
                                maxHeight: '120px',      
                                gap: 0.5,
                                width: '100%',
                                py: 0.5,
                                '&::-webkit-scrollbar': {
                                    width: '4px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#bbb',
                                    borderRadius: '4px',
                                },
                            }}
                        >
                            {value.map((option, index) => (
                                <Chip
                                    {...getTagProps({ index })}
                                    key={option?.id ?? index}
                                    label={safeGetOptionLabel(option)}
                                    size="small"
                                />
                            ))}
                        </Box>
                    )}

                    renderInput={(params) => (
                        <TextField
                            error={!!error}
                            helperText={error?.message}
                            {...params}
                            {...other}
                        />
                    )}
                />
            )}
        />
    );
}